import { render, staticRenderFns } from "./TrainingCoursesTabActions.vue?vue&type=template&id=d2602656&"
import script from "./TrainingCoursesTabActions.vue?vue&type=script&lang=js&"
export * from "./TrainingCoursesTabActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports